import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BreadcrumbsModule } from "src/app/components/elementi-strutturali/breadcrumbs/breadcrumbs.module";
import { PaginatorModule } from "src/app/components/elementi-strutturali/paginator/paginator.module";
import { ActionsListComponent } from "src/app/shared/components/actions-list/actions-list.component";
import { HorizontalBandComponent } from "src/app/shared/components/horizontal-band/horizontal-band.component";
import { SocialShareComponent } from "src/app/shared/components/social-share/social-share.component";
import { TagLayoutComponent } from "./tag-layout.component";

@NgModule({
  imports: [CommonModule, RouterModule, BreadcrumbsModule, PaginatorModule, HorizontalBandComponent, SocialShareComponent, ActionsListComponent],
  declarations: [TagLayoutComponent],
  exports: [TagLayoutComponent],

})
export class TagLayoutModule {
  static component = TagLayoutComponent
}